var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTableFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M3.318 6.404A.25.25 0 0 1 3.514 6h12.918a.25.25 0 0 1 .184.419l-4.853 5.294a1 1 0 0 0-.263.676v5.43a.25.25 0 0 1-.17.238l-2.5.833a.25.25 0 0 1-.33-.237v-5.307a1 1 0 0 0-.214-.618z"
})));
export default SvgIconTableFilter;